import { Component } from 'vue-property-decorator';

import formatters from '@/views/formatters';
import {
  METRICS_CUSTOM_COLUMN,
  CAMPAIGNS_EXTERNAL_STATUS_PROPELLER,
  YES_NO,
  POSTBACK_SENT_FAILED,
  METRICS_CUSTOM_EVENT,
  METRICS_CUSTOM_EVENT_REVENUE,
  METRICS_CUSTOM_EVENT_HIDDEN_REVENUE,
  COLUMN_WITH_INTEGRATION, 
  SUSPICIOUS_EVENT, 
  REPORTS_COST
} from '@/services/constants/report';
import { mixins } from 'vue-class-component';
import ReportBase from '@/views/reports/report-base';

@Component
class Formatter extends mixins<ReportBase>(ReportBase) {
  formatCellValue({ value, obj, isFooter } : {value: string, obj: any, isFooter?: boolean}) {
    let component;
    let result;
 
    const data = obj[value];

    if (data && data.tag !== 'div' || !data) {
      if (typeof data === 'string' && /^<i>[^<>]+<\/i>$/.test(data)) {
        component = this.$createElement('div', { domProps: { innerHTML: data } }, []);
      }
      else {
        component = this.$createElement('div', data, []);
      }
    }
    
    result = component;

    if (value === 'campaigns-externalstatus' && obj['DT_RowIntegrationType'] === 'propeller' ) {
      const formatter: Function = (formatters as any)[CAMPAIGNS_EXTERNAL_STATUS_PROPELLER];
      return formatter({ vtag: this.$createElement, component, ctx: this, data: obj, key: value });
    }
    if (value === 'flow_rules-default' || value === 'flow_rule_paths-directlinking') {
      if (isFooter) {
        return this.$createElement('div');
      }
      const formatter: Function = (formatters as any)[YES_NO];
      return formatter({ vtag: this.$createElement, component, ctx: this, data: obj, key: value });
    }
    if (value === 'postbacks-status') {
      const formatter: Function = (formatters as any)[POSTBACK_SENT_FAILED];
      return formatter({ vtag: this.$createElement, component, ctx: this, data: obj, key: value });
    }

    if (value === 'reports-cost' && obj['DT_RowIntegrationStatus']==='active' ) {
      const formatter: Function = (formatters as any)[REPORTS_COST];
      return formatter({ vtag: this.$createElement, component, ctx: this, data: obj, key: value });
    }

    if (!isFooter && (['reports-blacklistedip', 'reports-datacenterip','live_visits-ip_with_frequent_events','live_visits-ip_with_frequent_campaign_events','live_clicks-ip_with_frequent_events','live_clicks-ip_with_frequent_campaign_events','live_clicks-fast_clicker'].includes(value) )) {
      const formatter: Function = (formatters as any)[SUSPICIOUS_EVENT];
      return formatter({ vtag: this.$createElement, component, ctx: this, data: obj, key: value });
    }

    if (value === 'campaigns-name' && !!obj['DT_RowCampaignExternalStatus'] && obj['DT_RowIntegrationType'] === 'propeller') {
      const formatter: Function = (formatters as any)[COLUMN_WITH_INTEGRATION];
      return formatter({ vtag: this.$createElement, component, ctx: this, data: obj, key: value });
    }

    // main column
    if (obj.DT_RowName === obj[value]) {
      const formatter: Function = formatters.main_column;
      return formatter({ vtag: this.$createElement, component, ctx: this, data: obj, key: value, colors: this.$colors });
    }

    if (formatters?.[value]) {
      const formatter: Function = (formatters as any)[value];
      return formatter({ vtag: this.$createElement, component, ctx: this, data: obj, key: value, colors: this.$colors });
    }


    if (value.startsWith(METRICS_CUSTOM_EVENT)) {
      const formatter: Function = formatters[METRICS_CUSTOM_EVENT];
      return formatter({ vtag: this.$createElement, component, ctx: this, data: obj, key: value });
    }

    if (value.startsWith(METRICS_CUSTOM_EVENT_REVENUE)) {
      const formatter: Function = (formatters as any)[METRICS_CUSTOM_EVENT_REVENUE];
      return formatter({ vtag: this.$createElement, component, ctx: this, data: obj, key: value });
    }

    if (value.startsWith(METRICS_CUSTOM_EVENT_HIDDEN_REVENUE)) {
      const formatter: Function = (formatters as any)[METRICS_CUSTOM_EVENT_HIDDEN_REVENUE];
      return formatter({ vtag: this.$createElement, component, ctx: this, data: obj, key: value });
    }


    if (value.startsWith(METRICS_CUSTOM_COLUMN)) {
      const formatter: Function = (formatters as any)[METRICS_CUSTOM_COLUMN];
      const column = this.$store.getters.getCustomColumns[(value.slice(METRICS_CUSTOM_COLUMN.length))]

      if (column) {
        const { format, decimalPlaces } = column
        return formatter({
          vtag: this.$createElement,
          component,
          ctx: this,
          data: obj,
          key: value,
          format,
          decimal: decimalPlaces,
          colors: this.$colors
        });
      }
    }

    return  result
  }
}

export default Formatter;
